import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconWhatsapp: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 21 21">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0078 15.0084C11.1364 14.9418 8.1572 13.4634 6.11557 9.91724C5.39132 8.65621 5.49506 7.21894 6.55796 6.23204C6.91617 5.8972 7.36639 5.97944 7.7892 6.04994C7.89295 6.0656 8.0006 6.22421 8.05345 6.3417C8.32554 6.96047 8.59371 7.57924 8.83056 8.21367C8.95584 8.54851 8.72486 8.86377 8.24137 9.42183C8.08673 9.59807 8.05541 9.76059 8.17482 9.96619C8.95976 11.2958 10.0579 12.2572 11.5005 12.8211C11.7119 12.9034 11.8705 12.8525 12.0056 12.686C12.7709 11.752 12.8492 11.4798 13.2505 11.6717C15.1864 12.5979 15.3371 12.6351 15.3469 12.8544C15.4135 14.4856 13.916 15.075 13.0097 15.0084H13.0078Z"
      fill="currentColor"
    />
  </Svg>
)
